<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Multiselect from 'vue-multiselect';
import Repositories from '@/repositories';
const AllocationsRepository = Repositories.get('allocations');
const ItemsRepository = Repositories.get('items');

export default {
  props: {
    dataType: String,
    itemData: Object,
  },
  components: {
    Loading,
    Multiselect,
  },
  data() {
    return {
      item: null,
      fullItem: null,
      isLoading: false,
      title: '',
      toReceive: 0,
      damaged: 0,
      allocation: {
        idPublic: null,
        name: null,
      },
      allocationsOptions: [],
    };
  },
  computed: {},
  methods: {
    modalShow() {
      this.title =
        this.dataType === 'received'
          ? this.$t('receptions.received')
          : this.dataType === 'damaged'
          ? this.$t('receptions.damagedQty')
          : this.dataType === 'allocation'
          ? this.$t('general.allocation')
          : '';

      this.item = this.itemData;
      this.toReceive = this.itemData.toReceive;
      this.damaged = this.itemData.damagedQuantity;

      if (this.dataType === 'allocation') {
        this.isLoading = true;
        let promise = AllocationsRepository.getAll().then((response) => {
          this.allocationsOptions = this.groupAllocations(response.data.data);
        });
        let promise2 = ItemsRepository.get(this.item.itemIdPublic).then(
          ({ data }) => {
            this.fullItem = data;
          }
        );

        Promise.all([promise, promise2])
          .then(() => {
            this.allocation = this.allocationsOptions.reduce(
              (acc, allocationGroup) => {
                let location = acc.concat(allocationGroup.locations);
                return (
                  location.filter(
                    (x) => x.idPublic === this.item.allocationIdPublic
                  ) ?? null
                );
              },
              []
            );
            this.isLoading = false;
          })
          .catch(() => {
            this.$toast.errorToast(this.$t('errors.errorLoading'));
            this.isLoading = false;
          });
      }
    },
    groupAllocations(allocations) {
      let newArray = allocations.reduce((acc, location) => {
        let allocationGroupIdPublic = location.allocationGroupIdPublic;
        let allocationGroupName = location.allocationGroupName;

        let group = acc.find(
          (group) => group.allocationGroupIdPublic === allocationGroupIdPublic
        );
        if (!group) {
          group = {
            allocationGroupName: allocationGroupName,
            allocationGroupIdPublic: allocationGroupIdPublic,
            locations: [],
          };
          acc.push(group);
        }

        group.locations.push({
          name: location.name,
          idPublic: location.idPublic,
        });

        return acc;
      }, []);

      return newArray;
    },
    onCancel() {
      this.item.toReceive = this.toReceive;
      this.item.damagedQuantity = this.damaged;
      this.allocation.idPublic = null;
      this.allocation.name = null;
    },
    changeAllocation() {
      this.isLoading = true;
      this.fullItem.allocationIdPublic = this.allocation.idPublic;

      ItemsRepository.update(this.fullItem, this.item.itemIdPublic)
        .then(() => {
          this.item.allocationIdPublic = this.allocation.idPublic;
          this.item.allocationName = this.allocation.name;
          this.isLoading = false;
        })
        .catch(() => {
          this.$toast.errorToast(this.$t('errors.errorLoading'));
          this.isLoading = false;
        });
    },
    onChange(orderItem) {
      if (isNaN(orderItem.toReceive)) orderItem.toReceive = 0;
    },
  },
};
</script>

<template>
  <div>
    <b-modal
      id="item-data"
      centered
      @show="modalShow()"
      @cancel="onCancel()"
      @close="onCancel()"
      :title="title"
      no-close-on-backdrop
      no-close-on-esc
    >
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        color="#f1b44c"
        :width="70"
        :height="70"
        loader="dots"
        :is-full-page="false"
      >
      </loading>
      <div v-if="this.dataType == 'received' && item != null">
        <b-form-input
          v-model="item.toReceive"
          min="0"
          type="number"
          placeholder="0"
          @change="onChange(item)"
        ></b-form-input>
      </div>
      <div v-if="this.dataType == 'damaged'">
        <b-form-input
          v-model="item.damagedQuantity"
          min="0"
          type="number"
          placeholder="0"
        ></b-form-input>
      </div>
      <div v-if="this.dataType == 'allocation'">
        <multiselect
          id="input-allocation"
          v-model="allocation"
          :options="allocationsOptions"
          group-label="allocationGroupName"
          group-values="locations"
          :show-labels="false"
          :searchable="true"
          :label="'name'"
          track-by="idPublic"
          :placeholder="$t('general.pickAValue')"
          @input="changeAllocation"
          ><template v-slot:noOptions>
            {{ $t('general.noResult') }}
          </template>
        </multiselect>
      </div>
    </b-modal>
  </div>
</template>


<style>
</style>